export default __webpack_public_path__ + "static/media/world-map-addresses.604ebf3e.svg";